export const ROUTES = [
    '/consulta-soat',
    '/consulta-soat/resultado-cliente',
    '/consulta-soat/resultado-no-cliente',
    '/consulta-soat/error'
]